/**
 * Layout autenticado (`/_app`). El componente vive en `features/shell/app-shell.tsx` (carga de
 * `GET /me`, redirección a `/ingresar` con `401`, esqueleto y error con "Reintentar").
 */
import { createFileRoute } from '@tanstack/react-router';

import { AppShell } from '../features/shell/app-shell';

export const Route = createFileRoute('/_app')({
  component: AppShell,
});
